import React from "react";

const MergeBookedCandidateContracts = ({ cls }) => {
  return (
    <svg
      width="20"
      height="13"
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M19 7.5H12.6C11.5 7.5 10.4 7.2 9.4 6.7C8.4 6.2 7.6 5.4 6.9 4.5C6 3.3 4.5 2.5 2.9 2.5H1C0.4 2.5 0 2.1 0 1.5C0 0.9 0.4 0.5 1 0.5H2.9C5.1 0.5 7.2 1.6 8.5 3.4C8.9 4 9.5 4.6 10.2 4.9C10.9 5.3 11.7 5.4 12.4 5.4H19C19.6 5.4 20 5.8 20 6.4C20 7 19.6 7.5 19 7.5Z"
        fill="currentColor"
      />
      <path
        d="M3 12.5H1C0.4 12.5 0 12.1 0 11.5C0 10.9 0.4 10.5 1 10.5H3C3.8 10.5 4.6 10.3 5.2 10C5.9 9.6 6.5 9.1 6.9 8.5C7.5 7.6 8.4 6.9 9.4 6.3C10.4 5.8 11.5 5.5 12.6 5.5H18C18.6 5.5 19 5.9 19 6.5C19 7.1 18.6 7.5 18 7.5H12.5C11.7 7.5 10.9 7.7 10.3 8C9.6 8.4 9 8.9 8.6 9.5C8 10.4 7.1 11.1 6.1 11.7C5.1 12.2 4 12.5 3 12.5Z"
        fill="currentColor"
      />
      <path
        d="M16 10.5C15.7 10.5 15.5 10.4 15.3 10.2C14.9 9.8 14.9 9.2 15.3 8.8L17.6 6.5L15.3 4.2C14.9 3.8 14.9 3.2 15.3 2.8C15.7 2.4 16.3 2.4 16.7 2.8L19.7 5.8C20.1 6.2 20.1 6.8 19.7 7.2L16.7 10.2C16.5 10.4 16.3 10.5 16 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MergeBookedCandidateContracts;
